export default {
	posts: '글 목록 관리',
	category: '카테고리 관리',
	theme: '테마 관리',
	etc: '기타 설정',
	config: '설정 파일 수정',
};
